$(document).ready(function() {
  $(window).resize(function() {
  });

  $.widget("ui.bidsChart", {
    _init: function(){
      var widget = this;
      widget.chartData = ChartUtils.filter(widget.options.chartData, ChartUtils.rootFiltering);
      widget._adjustSeriesNames();

      widget.defaultChartOptions = {
        exporting: {
          buttons: {
            contextButton: {
                menuItems: ['printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG']
            }
          }
        },
        colors: ['#330000', '#003399', '#996600', '#003333', '#000033', '#660099', '#330000', '#660000', '#990033', '#99cc66', '#336600', '#009900', '#009999', '#006666', '#003366', '#000066', '#0066ff', '#660066', '#996666', '#999966'],

        chart: {
          renderTo: widget.element[0],
          defaultSeriesType: 'bar',
          marginTop: 35,
          height: widget._determineHeight(),
          width: widget._determineWidth()
        },
        plotOptions: {
          bar: {
            pointPadding: 0.1, groupPadding: 0.1,
            stacking: 'normal'
          },
          series: {
            pointWidth:30,
            borderWidth: 0, shadow: false,
            events:{
              click: function(e){
                if( !e.point.series.options.isLeaf ){
                  var selfCategory = e.point.series.options.self;
                  var selfCategoryName = e.point.series.name;

                  $('#bids-breadcrumb #bids-path').show();
                  widget.updateBreadCrumb(selfCategoryName, selfCategory);

                  $("#currentDataParentCategory").attr("value",selfCategory);

                  widget.filterDataByCategory();
                }
              },
              mouseOver: function(){
              }
            }
          }
        },
        legend: {
          align: 'center',
          verticalAlign: 'bottom',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false,
          reversed: true
        },
        credits: false,
        title: { text: null },
        xAxis: {
          title: { text: null },
          maxPadding: 0.01,
          labels: { rotation: 0, align: 'left', style: 'font-weight: bold', x: 5, y: widget._determineLabelDistance(),
            formatter: function(){
              // these are really Y axis labels
              return '<b>' + this.value + '</b> ' + $("#biddersList a:contains('" + this.value + "')").parent().find("p").text();
            }
          }
        },
        yAxis: {
          title: { text: null },
          stackLabels: {
            enabled: true,
            formatter: function(){
                return widget._formatStackLabels(this, this.total)
            }
          },
          maxPadding: 0.01,
          labels: {
            step: 2,
            formatter: function(){
              // these are really X axis labels --> look for negative values
              return Highcharts.numberFormat(this.value/1000,0);
            }
          }
        },
        tooltip: {
          formatter: function() {
            return ChartUtils.getTooltip(this, widget);
          }
        }
      };

      this.bar();
    },

    _adjustSeriesNames: function() {
      $.each(this.options.chartData.series, function(i,serie){
        if (serie.name.length > 25) {
          serie.name = serie.name;
        }
      });
    },

    _recalculateSize: function() {
      var widget = this;
      var options = function(opts) {
        opts.xAxis.labels.y = widget._determineLabelDistance();
      };
      this._showChart(this.chartData, options);
    },

    _determineMargin: function(){
      return (this.chartData.categories.length % 5) * 25 + 30;
    },

    _determineGroupedHeight: function() {
      return 20 * 1.5 * this.chartData.categories.length * this.chartData.series.length;
    },


    _determineHeight: function( categories ){
      var containerHeight = $('#page_tenders').height();
      var height = this.chartData.totals.length * 60;

      if (height < containerHeight)
        return containerHeight;
      else
        return height;
    },

    _determineWidth: function(){
      return $('.content.active').width();
    },

    _determineLabelDistance: function(){
      var h = this._determineHeight();
      var categories = this.chartData.categories.length;
      var categoryHeight = h / categories;
      var labelDistance = (categoryHeight * -0.2) - (categories * 0.5);
      return labelDistance;
    },

    _showChart: function(data, chartOptionsFunc){
      if(this.chart != null){
        this.chart.destroy();
      }

      var optionsDeepCopy = $.extend( true, {}, this.defaultChartOptions);

      //set the chart data
      optionsDeepCopy.xAxis.categories = data.categories;
      optionsDeepCopy.series = data.series;

      //modifies a deep copy of the default options
      if(chartOptionsFunc != null){
        chartOptionsFunc.call(this, optionsDeepCopy);
      }
      this.chart = new Highcharts.Chart(optionsDeepCopy, function(chart) {
        if (chart.series.length < 1) {
          $('#page_tenders').height(200);

          var textX = chart.plotLeft + (chart.plotWidth  * 0.5);
          var textY = chart.plotTop  + 50;

          chart.renderer.text(I18n.t('tender_chart_no_data'), textX, textY)
            .css({
              color: '#333333',
              fontSize: '12px'
            })
            .add();
        };
      });
    },

    //Chart Methods

    lines: function(){
      ChartUtils.drawLinesChart(null, this)
    },

    stackedPercentage: function(){
      var customOpts = function(opts){
        var widget = this;

        opts.plotOptions.bar.stacking = 'percent';
        opts.yAxis.labels.formatter = function(){ return this.value + '%'; };

        opts.chart.height= widget._determineHeight();
        opts.chart.width = widget._determineWidth();
        var yAxisLower = opts.yAxis;
        yAxisLower.title.text = "Percentage";
        var yAxisUpper = $.extend(true, {}, yAxisLower);
        yAxisUpper.opposite = true;
        yAxisUpper.linkedTo = 0;
        opts.yAxis = [yAxisLower, yAxisUpper];
        opts.xAxis.labels.formatter = function() { return ChartUtils.labelFormatter(this, true); }
        opts.series[0].dataLabels = { enabled: false };
      }

      this._showChart(this.chartData, customOpts);
    },

    _getCurrentTotals: function() {
      var widget = this;
      var totals = {
          max: 0,
          min: null,
          absoluteMin: 0
      };
      $.each(widget.chartData.categories, function(categoryIndex, categoryName){
        totals[categoryIndex] = {
          total: 0,
          categoryMin: 0,
          minPositiveSerie: null,
          categoryName: categoryName
        };
        $.each(widget.chartData.series, function(i, serie) {
          totals[categoryIndex]['total'] += serie.data[categoryIndex];
          if (serie.data[categoryIndex] < 0) {
            if (serie.data[categoryIndex] < totals[categoryIndex]['categoryMin']) {
              totals[categoryIndex]['categoryMin'] = serie.data[categoryIndex];
            }
            if (serie.data[categoryIndex] < totals.absoluteMin) {
              totals.absoluteMin = serie.data[categoryIndex];
            }
          } else {
            if (totals[categoryIndex]['minPositiveSerie'] == null) {
              totals[categoryIndex]['minPositiveSerie'] = i;
            }
          }
        });
        if (totals[categoryIndex]['total'] > totals.max) {
            totals.max = totals[categoryIndex]['total'];
        }
        if (totals.min == null || totals[categoryIndex]['total'] < totals.min) {
            totals.min = totals[categoryIndex]['total'];
        }
      });
      return totals;
    },

    _formatNumber: function(number) {
      var number = Highcharts.numberFormat(number,0);
      return this.chartData.currency + ' ' + number;
    },

    _formatStackLabels: function(instance, total){
        var widget = this;
//        var category = $.trim(instance.point.category);
//        var labelColor;
//
//        currentTotals = this._getCurrentTotals();
//
//        if (category == 'Median' || category == 'Average') {
//        labelColor = ChartUtils.getLabelColor(category);
//        } else {
//        if (total == currentTotals.min) {
//          labelColor = ChartUtils.getLabelColor('min');
//        } else if (total == currentTotals.max) {
//          labelColor = ChartUtils.getLabelColor('max');
//        } else {
//          labelColor = ChartUtils.getLabelColor('normal');
//        }
//        }
        return  widget._formatNumber(total)
    },

    bar: function(){
      var customOpts = function(opts){
        var widget = this;

        opts.chart.height= widget._determineHeight();
        opts.chart.width = widget._determineWidth();

        currentTotals = this._getCurrentTotals();

        opts.yAxis.max = currentTotals.max * 1.10;
        opts.yAxis.min = (currentTotals.absoluteMin > 0) ? 0 : currentTotals.absoluteMin * 1.10;

        opts.yAxis.labels.formatter = function() {
          var max = currentTotals.max;
          var decimals = (max / 1000) > 1 ? 0 : 1;
          return Highcharts.numberFormat(this.value/1000,decimals);
        };

        var yAxisLower = opts.yAxis;
        var yAxisUpper = $.extend(true, {}, yAxisLower);
        yAxisUpper.opposite = true;
        yAxisUpper.linkedTo = 0;
        opts.yAxis = [yAxisLower, yAxisUpper];

        opts.xAxis.labels.formatter = function() { return ChartUtils.labelFormatter(this, false); }

        var totalObjects = _.select(currentTotals, function(total){
          return typeof(total.minPositiveSerie) != 'undefined' && total.minPositiveSerie !== null;
        });
        var seriesWithLabels = _.map(totalObjects, function(t) {
          return t.minPositiveSerie;
        });
        seriesWithLabels = $.unique(seriesWithLabels).sort();
      };
      this._showChart(this.chartData, customOpts);
    },

    grouped: function(){
      var customOpts = function(opts){
        var widget = this;
        opts.tooltip.formatter = function() {
          return '<b>' + this.x + '</b><br/>' + this.series.name + ': ' + Highcharts.numberFormat(this.y, 0);
        };

        var yAxisLower = opts.yAxis;
        var yAxisUpper = $.extend(true, {}, yAxisLower);
        yAxisUpper.opposite = true;
        yAxisUpper.linkedTo = 0;
        opts.yAxis = [yAxisLower, yAxisUpper];

        opts.xAxis.labels = { align: 'right' };
        opts.xAxis.labels.formatter = function(){
          return '<b>' + this.value + '</b> ' + $("#biddersList a:contains('" + this.value + "')").parent().find("p").text();
        }
        opts.plotOptions.series.pointWidth = 20;
        opts.plotOptions.bar.pointPadding = 0.1;
        opts.plotOptions.bar.groupPadding = 0.05;
        opts.chart.height = this._determineGroupedHeight();
        opts.chart.width = this._determineWidth();

        opts.plotOptions.series.events.click = function(e){

            var isLeaf = this.options.leaves[e.point.x];
            var selfCategory = this.options.categories[e.point.x];
            var selfCategoryName = e.point.category;

            // this.data[0].category = "preliminaries and ...";
            // this.data[0].x = 0;

            if (!isLeaf) {
              widget.updateBreadCrumb(selfCategoryName, selfCategory);
              $("#currentDataParentCategory").attr("value",selfCategory);
              widget.filterDataByCategory();
            }
          }

//        opts.plotOptions.series.dataLabels = {
//          enabled: true,
//          formatter: function(){
//            var label = Highcharts.numberFormat(this.y,1);
//            label += " - " + this.series.name;
//            return label;
//          }
//        }

        var referencedBidder = $("#bids-comparison-chart").data('referencedBidder');
        if( ! _.isEmpty(referencedBidder) )
          opts.tooltip.formatter = function() {
            var referencedBidderName   = $("#selectedBidder").text();
            var referencedBidderAmount = referencedBidder[this.point.x];
            var currentCategoryName = this.point.category;
            var currentBidderName = this.point.series.name;
            var currentBidderAmount = this.y + referencedBidderAmount;

            var percentage = Highcharts.numberFormat( (currentBidderAmount / referencedBidderAmount - 1) * 100 , 1);
            if( percentage > 0 ) percentage = "+" + percentage;

            var tooltip = "<b>" + currentCategoryName + ":</b><br/>";
            tooltip += referencedBidderName +': '+ Highcharts.numberFormat( referencedBidderAmount, 1) + '<br/>';
            tooltip += '<span style="font-weight:bold; color:' + this.series.color + '>'
            tooltip +=   currentBidderName +': '+ Highcharts.numberFormat(currentBidderAmount, 1) + '</style> (' + percentage  + '%)';
            return tooltip;
          }
      }
      var groupedData = $.extend( true, {}, this.chartData);
      // var groupedData = this.chartData;
      var referenceIndex = $('#references-drop li a.selected').parent().index();
      if( referenceIndex != "" ){
        var bidderData = ChartUtils.prepareDataForReference(groupedData, parseInt(referenceIndex));
        $("#bids-comparison-chart").data('referencedBidder', bidderData );
      }else{
        $("#bids-comparison-chart").data('referencedBidder', [] );
      }
      var transposedData = ChartUtils.transposeSeriesIntoCategories( groupedData );
      this._showChart( transposedData, customOpts);
    }, //grouped

    //Filtering data series

    _filterDataWithCurrentParentCategory: function(){
      currentCategory = $("#currentDataParentCategory").attr("value");
      this.chartData = this._parentFiltering(this.options.chartData, currentCategory);
    },

    _parentFiltering: function(data, parentCategory ){
      var dataCopy = $.extend(true, {}, data);
      var newSeries = $.grep( dataCopy.series, function(datum){
        return datum.parent == parentCategory;
      });
      dataCopy.series = newSeries;
      return dataCopy;
    },

    // Filtering categories,

    _bidderFiltering: function(){
      var is_average_checked = $('#biddersList .average').parents('li').find('input').last().is(':checked');
      var is_median_checked = $('#biddersList .median').parents('li').find('input').last().is(':checked');
      var widget = this;
      var recalculated_total_average = 0;
      var recalculated_total_median = 0;
      //restricted bidders => unchecked bidders
      var restrictedBidderIndexes = BiddersUtils.getBidders('restricted');
      if( restrictedBidderIndexes.length > 0 ){

        restrictedBidderIndexes.sort();
        $.each(this.chartData.series, function(index, serie){
          var restricted_indexes = 0;
          var recalculated_average = 0;
          var recalculated_median = 0;

          for( var restrictedIndex=0; restrictedIndex < restrictedBidderIndexes.length; restrictedIndex++){
            // sliced data based on selected categories
            serie.data.splice( restrictedBidderIndexes[restrictedIndex] - restricted_indexes, 1);
            if(is_average_checked && is_median_checked)
            { //calculating average/median for individual categories
              recalculated_average = CommonUtils._recalculate_average(serie.data.slice(0,-4));
              recalculated_median = CommonUtils._recalculate_median(serie.data.slice(0,-4));
              serie.data[(serie.data.length-4)] = recalculated_average;
              serie.data[(serie.data.length-3)] = recalculated_median;
              restricted_indexes += 1;
            }
          }

          recalculated_total_average = recalculated_total_average + serie.data[(serie.data.length-4)]
          recalculated_total_median = recalculated_total_median + serie.data[(serie.data.length-3)]
        });

        var restricted_indexes = 0;
        for(var restrictedIndex=0; restrictedIndex < restrictedBidderIndexes.length; restrictedIndex++){
            this.chartData.categories.splice( restrictedBidderIndexes[restrictedIndex] - restricted_indexes, 1);
            this.chartData.totals.splice( restrictedBidderIndexes[restrictedIndex] - restricted_indexes, 1);
            restricted_indexes += 1;
        }
        //If no bidder is selected
        if(isNaN(recalculated_total_average))
            recalculated_total_average = 0;
        if(isNaN(recalculated_total_median))
            recalculated_total_median = 0;
      }
      else {
        // Calculate median/average of all categories if all bidders are selected
        $.each(this.chartData.series, function(index, serie){
          if(is_average_checked && is_median_checked)
          {
            recalculated_total_average = recalculated_total_average + serie.data[serie.data.length-4];
            recalculated_total_median = recalculated_total_median + serie.data[serie.data.length-3];
          }
        });
      }

      // Setting average dynamically
      if(is_average_checked && is_median_checked)
      {
        var formatted_average =  Highcharts.numberFormat(recalculated_total_average, 0);
        var formatted_median =  Highcharts.numberFormat(recalculated_total_median, 0);
        $('#biddersList .average').text(widget.chartData.currency + ' ' + formatted_average);
        // Setting median dynamically
        $('#biddersList .median').text(widget.chartData.currency + ' ' + formatted_median);
      }
    },

    filterBidders: function(){
      this._filterDataWithCurrentParentCategory();
      this._bidderFiltering();
      this._sortDataBySelector();
      this._bidderSorting();
      this._recalculateSize();
      eval("this." + this._chartType() + "()"); //redraw chart
    },

    filterDataByCategory: function(){
      this._filterDataWithCurrentParentCategory();
      this._sortDataBySelector();
      this._bidderSorting();
      this._recalculateSize();
      eval("this." + this._chartType() + "()"); //redraw chart
    },

    _chartType: function() {
      return $("#chartType-drop").parent().find('span').data('chartType') || 'bar';
    },

    _bidderSorting: function() {
      var widget = this;
      var bidders = widget.chartData.categories;
      var sortedBidders = CommonUtils.bidders.sorted;
      ChartUtils.sortDataInPlace(bidders,sortedBidders, widget.chartData.series);
    },
    _sortDataBySelector: function() {
      var selectedOption = $("#sortBidsBy-drop").parent().find('span').data('bidsSorting');
      this.sortData(selectedOption);
    },
    sortData: function(sortBy) {
      var data = this.chartData;
      switch (sortBy) {
        case "byAmount":
          this.chartData.totals = this.chartData.totals.sort(function(a,b) { return a.total > b.total ? 1 : -1; });

          var oldCategoryList = this.chartData.categories;
          var newCategoryList = $.map(this.chartData.totals, function(t) { return t.name; });
          this.chartData.categories = newCategoryList;
          this._sortSeries(oldCategoryList, newCategoryList);
          break;
        case "byDescAmount":
          this.chartData.totals = this.chartData.totals.sort(function(a,b) { return b.total > a.total ? 1 : -1; });

          var oldCategoryList = this.chartData.categories;
          var newCategoryList = $.map(this.chartData.totals, function(t) { return t.name; });
          this.chartData.categories = newCategoryList;
          this._sortSeries(oldCategoryList, newCategoryList);
          break;
        case "byName":
          this.chartData.totals = this.chartData.totals.sort(function(a,b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; });

          var oldCategoryList = this.chartData.categories;
          var newCategoryList = $.map(this.chartData.totals, function(t) { return t.name; });
          this.chartData.categories = newCategoryList;
          this._sortSeries(oldCategoryList, newCategoryList);
          break;
      }
      // ChartData = this.chartData;
    },
    _sortSeries: function(oldCategoryList, newCategoryList) {
      $.each(this.chartData.series, function(i, s) {
        var newData = [];
        $.each(newCategoryList, function(index, c){
          var oldIndex = oldCategoryList.indexOf(c);
          newData[index] = s.data[oldIndex];
        });
        s.data = newData;
      });
    },

    //BreadCrumbs utils

    updateBreadCrumb: function(newCategoryName, categoryId){
      var widget = this;
      var parentElement = $("ul#bids-path li").last();
      var parentElementId = parentElement.attr('id');
      parentElement.removeClass("last");
      parentElement.contents().wrap("<a href='#" + parentElementId + "' />");

      parentElement.contents().click( function(){ //Removes this and all following elements.
        $("ul#bids-path #" + parentElementId + " ~ li").remove();
        $("ul#bids-path #" + parentElementId ).addClass("last");
        $("ul#bids-path #" + parentElementId + " a").contents().unwrap();

        if (parentElementId == 'root') {
          $('#bids-breadcrumb #bids-path').hide();
        }
        var categoryIdForFilter = ( parentElementId == 'root') ? "" : parentElementId;
        $("#currentDataParentCategory").attr("value",categoryIdForFilter);
        widget.filterDataByCategory();

        return false;
      });
      $("ul#bids-path").append("<li id='" + categoryId + "' class='last'>" + newCategoryName + "</li>");
    },

    _detectNegativeValues: function() {
      var haveNegativeValues = false;
      var serie, value;
      for (i in ChartData.series) {
        serie = ChartData.series[i];
        for (j in serie.data) {
          value = serie.data[j];
          if (value < 0) {
            haveNegativeValues = true;
            break;
          }
        }
        if (haveNegativeValues) {
          break;
        }
      }
      return haveNegativeValues;
    }
  });

  // Event handling for Chart's view
  $(".chart-type").click(function(e) {
    e.preventDefault();
    ChartUtils.showOnDropDown($(this));

    var chartType = $(this).data('chartType');
    if (chartType == "grouped") {
      var referenceSelect = $("ul#references-drop");

      $("#biddersList li:has(input:checkbox[checked])").each( function( bidder_index, bidder){
        referenceOption = $("<li/>");
        referenceContent = $('<a class="bids-references"></a>');
        referenceContent.text( $(bidder).find("a").text() );
        referenceOption.append(referenceContent);
        referenceSelect.append( referenceOption );
      });

      $("#referenceViewOptions").append(referenceSelect).show();
      $("#referenceViewOptions").prev().show();
    } else {
      $("ul#references-drop").html('');
      $('#selectedBidder').html(I18n.t("v4.tenders.bidding_analysis.charts.select_bidder"));
      $("#referenceViewOptions").hide();
      $("#referenceViewOptions").prev().hide();
      if (chartType == "stackedPercentage") {
        // look for negative values in chart series
        if ($('#bids-comparison-chart').data().uiBidsChart) {
          var haveNegativeValues = $('#bids-comparison-chart').data().uiBidsChart._detectNegativeValues();
          if (haveNegativeValues) {

          }
        }
      }
    }

    $("#bids-comparison-chart").bidsChart("filterBidders");
  });

  $(document).on('click', '.bids-references', function(){
    var $selected = $(this);
    var $targets = $('#references-drop');

    $targets.find('a').removeClass('selected');
    $(this).addClass('selected');
    $targets.parent().find('span').text($selected.html());
    $("#bids-comparison-chart").bidsChart("grouped");
  });

});
